import React from 'react';
import { Box, Divider, Link, SxProps, Theme, Typography } from '@mui/material';
import Markdown, { Components } from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';

const headingStyle = { fontWeight: 600, mb: 0, mt: 3 };

const markdownComponents: Components = {
  h1: ({ node, ...props }: { node?: any }) => <Box sx={headingStyle} {...props} />,
  h2: ({ node, ...props }: { node?: any }) => <Box sx={headingStyle} {...props} />,
  h3: ({ node, ...props }: { node?: any }) => <Box sx={headingStyle} {...props} />,
  h4: ({ node, ...props }: { node?: any }) => <Box sx={headingStyle} {...props} />,
  p: ({ node, ...props }: { node?: any }) => <Typography variant="body1" sx={{ mt: 1 }} {...props} />,
  a: ({ node, ...props }: { node?: any }) => <Link {...props} target="_blank" />,
  hr: ({ node, ...props }: { node?: any }) => <Divider sx={{ my: 2 }} {...props} />,
  ul: ({ node, ...props }: { node?: any }) => <Box component="ul" sx={{ pl: 3, m: 0 }} {...props} />,
  ol: ({ node, ...props }: { node?: any }) => <Box component="ol" sx={{ pl: 3, mt: 0, mb: 1 }} {...props} />,
  li: ({ node, ...props }: { node?: any }) => <Box component="li" sx={{ m: 0, '& p': { mt: 0 } }} {...props} />,
  blockquote: ({ node, ...props }: { node?: any }) => (
    <Box
      component="blockquote"
      sx={theme => ({
        borderLeft: `4px solid ${theme.palette.colors.neutrals[300]}`,
        color: theme.palette.colors.neutrals[600],
        pl: 2,
        ml: 0,
        my: 2,
        fontStyle: 'italic',
      })}
      {...props}
    />
  ),
  pre: ({ node, children, ...props }: { node?: any; children?: any }) => (
    <Box
      component="pre"
      sx={theme => ({
        background: theme.palette.colors.neutrals[200],
        borderRadius: theme.shape.borderRadius,
        fontFamily: 'monospace',
        overflowX: 'auto',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        px: 1,
        py: 0.5,
      })}
      {...props}>
      {children}
    </Box>
  ),
  code: ({ node, children, ...props }: { node?: any; children?: any }) => (
    <Box
      component="code"
      sx={theme => ({
        background: theme.palette.colors.neutrals[200],
        borderRadius: theme.shape.borderRadius,
        fontFamily: 'monospace',
      })}
      {...props}>
      {children}
    </Box>
  ),
};

const AvMarkdown = ({ content, sx = {} }: { content: string; sx?: SxProps<Theme> }) => (
  <Box sx={{ wordBreak: 'break-word', ...sx }}>
    <Markdown rehypePlugins={[rehypeSanitize]} components={markdownComponents}>
      {content}
    </Markdown>
  </Box>
);

export { AvMarkdown };
